<template>
	<div class="scrollable only-y">
		<div :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
			<div class="page-header card-base card-shadow--medium">
				<h2 class="no-m white-text">{{ editIdentity.maskingName || "-" }}</h2>
			</div>
		</div>
		<el-card>
			<el-tabs type="border-card" v-model="activeTab" @tab-click="tabClick">		  
			  <el-tab-pane label="Detail" name="detail">
			  	<el-form ref="form" label-width="180px">
				<el-form-item label="Type Facebook ID">
                    <template>
                        <el-row>
                            <el-col>
                                <el-select disabled style="width: 100%;" v-model="editIdentity.type" @change="handleChangeSelectedIdentity" filterable placeholder="Select Type">
									<el-option
									v-for="(item) in types" :key="item.label"
									:label="item.label"
									:value="item.value">
									</el-option>
								</el-select>
                            </el-col>
                        </el-row>
                    </template>
                </el-form-item>

				<el-form-item label="Identity Number">
                    <template>
                        <el-input :disabled="!activeEdit" @keypress.native="numberOnly" @paste.native="paste($event,'editIdentity','identityNumber')" v-model="editIdentity.identityNumber"></el-input>
                    </template>
                </el-form-item>

                <el-form-item label="Masking Name">
                    <template>
                        <el-input :disabled="!activeEdit" v-model="editIdentity.maskingName"></el-input>
                    </template>
                </el-form-item>

				<el-form-item label="PIC Business" v-if="editIdentity.type == 'waba_id'">
                    <el-select :disabled="!activeEdit" @change="handleChangeSelectedPicBusiness" style="width: 100%;" v-model="editIdentity.pic_business" v-if="editIdentity.pic_business != null">
                        <el-option v-for="s in options_picBusiness" filterable :key="s.user_id" :value="s.value" :label="s.label"/>
                    </el-select>
                    <el-select :disabled="!activeEdit" @change="handleChangeSelectedPicBusiness" style="width: 100%;" v-model="editIdentity.pic_business" v-else>
                        <el-option v-for="s in options_picBusiness" filterable :key="s.user_id" :value="s.value" :label="s.label"/>
                    </el-select>
                </el-form-item>

				<el-form-item label="Created By">
                    <template>
                        <el-input disabled v-model="editIdentity.adminName"></el-input>
                    </template>
                </el-form-item>

				<el-form-item label="Created At">
                    <template>
                        <el-input disabled :value="this.formatDate(editIdentity.dateCreate, 'DD/MM/YYYY HH:mm:ss')"></el-input>
                    </template>
                </el-form-item>

                <el-form-item>
                    <el-button v-if="activeEdit" type="primary" @click="editFacebookIdentity" :loading="loadingBtn">Save</el-button>     
                    <el-button v-if="activeEdit" @click="activeEdit=false">Cancel</el-button>
                    <el-button v-else type="primary" @click="activeEdit = true" :loading="loadingBtn">Edit</el-button>
                </el-form-item>
            </el-form>
            <el-button @click="$router.push('/business')" style="float: right; margin-bottom: 20px;" class="button">Back</el-button>
			  </el-tab-pane>
			  <el-tab-pane label="Special Price" name="price">
				<div>
                    <el-row>
                        <el-col :span="24" :md="24" :sm="24" :xs="24" justify="end" >
                            <el-card style="background: linear-gradient(45deg, rgb(36, 147, 147) 0%, rgba(85,85,85,1) 100%); color:#ffffff; font-weight:bold;" class="mb-10">
                                Total Data : <br>
                                <span style="font-size:32px;">{{ (totalPriceModel) }}</span>
                            </el-card>
                        </el-col>
                    </el-row>
					<!-- <el-row>
						<el-col>
							<el-select v-model="selectedFilterIdentity" placeholder="Filter By" style="width:140px;" :default-first-option="true" class="mb-10 mr-5">
								<el-option
								v-for="itm in filterByIdentity"
								:key="itm.value"
								:label="itm.label"
								:value="itm.value">
								</el-option>
							</el-select>
							<el-input
								style="width:250px;"
								class="mb-10"
								prefix-icon="el-icon-search"
								placeholder=""
								clearable
								v-model="searchPriceModel">
							</el-input>
							<el-button-group class="mr-10 ml-5">
								<el-button type="primary" :loading="loadingSession" class="animated fadeInRight" @click="changeFilterIdentity">
									<i class="el-icon-search"/>
								</el-button>
							</el-button-group>
						</el-col>
					</el-row> -->
                    <el-row>
						<el-col :span="12">
							<el-button class="mb-10" style="background-color: #3576F2; color: #FFFFFF;" @click="addDataPriceModel">Add New Data</el-button>
						</el-col>
						<el-col style="text-align: right;" :span="12">
							<span style="display: flex;">
								<el-select v-model="search_type" @change="doSearchFbPriceModel">
									<el-option value="country" label="Country Name"/>
									<el-option value="model" label="Model Name"/>
								</el-select>
								<el-input
									class="search-customer mb-10 fl-l" style="width:auto;"
									prefix-icon="el-icon-search"
									placeholder="Search Country Name"
									clearable
									@keypress.native="doSearchFbPriceModel"
									@clear="doSearchFbPriceModel"
									@keyup.native="doSearchFbPriceModel"
									v-model="searchPriceModel">
								</el-input>
							</span>
						</el-col>
                    </el-row>
				</div>

				<template>
					&nbsp;
					<el-pagination
						v-if="paginate"
						background
						prev-text="Prev"
						next-text="Next"
						layout="prev, pager, next"
						:page-size="10"
						@current-change="paginatePriceModel"
						:current-page="currentPagePriceModel"
						:total="parseInt(totalPriceModel)"/>
					<br/>
					<el-table :data="reqPriceModel" style="width: 100%;" v-loading="loadingTemplate" element-loading-text="Loading..." element-loading-spinner="el-icon-loading">
						<!-- <el-table-column prop="dateCreate" label="Created At" width="200">
							<template slot-scope="props">
								<p style="font-weight:bold;">{{ formatDate(props.row.dateCreate, "DD/MM/YY HH:mm:ss") }}</p>
							</template>
						</el-table-column> -->
						<el-table-column prop="facebook_price['domainName']" label="Domain" width="150">
							<template slot-scope="props">
								<p style="font-weight:bold;">{{ props.row.facebook_price != null ? props.row.facebook_price.domainName : "-" }}</p>
							</template>
						</el-table-column>
						<el-table-column prop="facebook_price['countryName']" label="Country Name" width="200">
							<template slot-scope="props">
								<p style="font-weight:bold;">{{ props.row.facebook_price != null ? props.row.facebook_price.countryName : "-" }}</p>
							</template>
						</el-table-column>
						<el-table-column prop="facebook_price['modelname']" label="Price Model" width="200">
							<template slot-scope="props">
								<p style="font-weight:bold;">{{ props.row.facebook_price != null ? (props.row.facebook_price.modelName || "-") : "-" }}</p>
							</template>
						</el-table-column>
						<el-table-column prop="periodeStart" label="Start Periode" width="180">
							<template slot-scope="props">
								<p style="font-weight:bold;">{{ props.row.periodeStart ? formatDate(props.row.periodeStart, "DD/MM/YYYY") : '-' }}</p>
							</template>
						</el-table-column>
						<el-table-column prop="periodeEnd" label="Updated At" width="180">
							<template slot-scope="props">
								<p style="font-weight:bold;">{{ props.row.periodeEnd ? formatDate(props.row.periodeEnd, "DD/MM/YYYY") : '-' }}</p>
							</template>
						</el-table-column>
                        <el-table-column prop="facebook_price['price_bi']" label="Price BI" width="180">
							<template slot-scope="props">
								<p style="font-weight:bold;">{{ formatPrice(props.row.facebook_price.price_bi) }}</p>
							</template>
						</el-table-column>
						<el-table-column prop="facebook_price['price_ui']" label="Price UI" width="180">
							<template slot-scope="props">
								<p style="font-weight:bold;">{{ formatPrice(props.row.facebook_price.price_ui) }}</p>
							</template>
						</el-table-column>
                        <el-table-column prop="adminId" label="Created By" width="180">
							<template slot-scope="props">
								<p style="font-weight:bold;">{{ props.row.admin ? props.row.admin.username : '-' }}</p>
							</template>
						</el-table-column>
                        <el-table-column prop="dateCreate" label="Created At" width="180">
							<template slot-scope="props">
								<p style="font-weight:bold;">{{ props.row.dateCreate ? formatDate(props.row.dateCreate, "DD/MM/YYYY HH:mm:ss") : '-' }}</p>
							</template>
						</el-table-column>
	                    <el-table-column
		                    fixed="right"
		                    label="Action"
		                    width="300">
	                        <template slot-scope="scope">
								<!-- <el-button v-if="scope.row.type == 'waba_id'" type="primary" size="small" @click="detailFbIdentity(scope.row)">Detail</el-button>
								<el-button v-else size="small" @click="detailFbIdentity(scope.row)">Edit</el-button> -->
								<el-button size="small" type="danger" @click="deletePriceModel(scope.row)">Delete</el-button>
	                        </template>
	                    </el-table-column>
					</el-table>
					&nbsp;
					<el-pagination
						v-if="paginate"
						background
						prev-text="Prev"
						next-text="Next"
						layout="prev, pager, next"
						:page-size="10"
						@current-change="paginatePriceModel"
						:current-page="currentPagePriceModel"
						:total="parseInt(totalPriceModel)"/>
					<br/>
				</template>
			  </el-tab-pane>
			</el-tabs>
		</el-card>

		<el-dialog :close-on-click-modal="false" title="Add Price Model" :visible.sync="dialogFormVisibleIdentity">
		<div v-loading="loadingIdentity">
            <el-form label-position="top" ref="form" label-width="120px">
				<el-form-item label="Identity Number">
                    <template>
                        <el-input  disabled @keypress.native="numberOnly" @paste.native="paste($event,'identityNumber')" v-model="editIdentity.identityNumber"></el-input>
                    </template>
                </el-form-item>

                <el-form-item label="Masking Name">
                    <template>
                        <el-input disabled v-model="editIdentity.maskingName"></el-input>
                    </template>
                </el-form-item>

				<el-form-item v-if="editIdentity.type == 'waba_id'" label="Meta Price Model">
                    <template>
                        <el-row :gutter="5" v-for="(row,i) in price_model_identity" :key="i">
                            <el-col :span="8">
                                <el-date-picker 
									style="width:100%;"
									v-model="row.model.periode"
									range-separator="To"
									type="daterange"
									start-placeholder="Start date"
                                    end-placeholder="End date">
								</el-date-picker>
                            </el-col>
                            <el-col :span="5">
                                <el-select style="width: 100%;" v-model="row.model.countryName" @change="handleChangeSelectedCountryModel(row.model.countryName,i)" filterable placeholder="Select Country">
                                <el-option
                                v-for="(item) in countries" :key="item.countryCode"
                                :label="item.countryNameEn"
                                :value="item.countryNameEn">
                                <div>
                                    <span style="margin-right: 5px;"><country-flag :country='`${item.countryCode.toLowerCase()}`' size='small'/></span>
                                    <span style="font-size: 12px">{{ item.countryNameEn + ` (+${item.countryCallingCode})` }}</span>
                                </div>
                                </el-option>
                            </el-select>
                            </el-col>
                            <el-col :span="2">
                                <el-input disabled v-model="row.model.domainName"></el-input>
                            </el-col>
                            <el-col :span="5">
                                <el-select :disabled="!row.model.countryName" style="width: 100%;" v-model="row.model.id" @change="handleChangeSelectedModel(row.model.id,i)" filterable placeholder="Select Model">
                                <el-option
                                v-for="(item) in reqFbPriceIdentity[i]" :key="item.id"
                                :label="item.modelName || '-'"
                                :value="item.id">
                                </el-option>
                            </el-select>
                            </el-col>
							<el-col v-if="price_model_identity.length < 10" style="text-align: center;" :span="2">
                                <el-button type="primary" size="mini" @click="addModel">+</el-button>
                            </el-col>
							<el-col style="text-align: left;" v-if="i > 0" :span="2">
                                <el-button type="danger" size="mini" @click="deleteModel(i)">-</el-button>
                            </el-col>
                        </el-row>
                    </template>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="addFacebookPriceModel" :loading="loadingBtn">Save</el-button>
                    <el-button @click="dialogFormVisibleIdentity=false">Cancel</el-button>
                </el-form-item>
            </el-form>
		
		</div>
        </el-dialog>

		<el-card class="mt-20 mb-20 card-base" style="border:none; color:white;">
			DAM Corp.
		</el-card>
	</div>
</template>

<script>
import api from '@/networkClient'
import config from '@/config'
const _ = require('lodash')
const moment = require('moment')
import CountryFlag from 'vue-country-flag'
const countryCodes = require('country-codes-list')

export default {
	name: 'HSM',
	data () {
		return {
			search_type: "country",
			searchFbPriceModel: "",
            fb_identity: "",
            activeEdit: false,
			paginate: true,
			processList:[],
			options_picBusiness: [],
			bodyStyle: {
				padding: "20px"
			},
			loadingSession: false,
			filterInputSession:"",
			filterByIdentity: [{value:"waba_id", label:"WABA ID"},{value:"masking_name", label:"Masking Name"}],
			filterBySession:[{value:"waba_id", label:"WABA ID"},{value:"phone_number", label:"Phone Number"}],
			selectedFilterSession:"waba_id",
			selectedFilterIdentity: "waba_id",
			selectedStartDateSession: [
                moment().subtract(1,"day").format("YYYY-MM-DD"),
                moment().format("YYYY-MM-DD")
            ],
            price_bi: 0,
            price_ui: 0,
            country_code: '',
            country_name: "",
            domain_name: '',
			types: [{label: "WABA ID", value: "waba_id"},{label: "FBBM ID", value: "fbbm_id"}],
            countries: [],
			mapingCountries: [],
			reqFbPriceIdentity:[],
			price_model_identity:[{model:{periode:[null,null],modelName: "",countryName: "", domainName:""}}],
            model_name:"",
			type_identity:"waba_id",
			identityNumber: "",
			maskingName: "",
            price_model: "1",
			price_model_edit: "1",
			editTemplate: {
				dialog: false,
				object: {},
				loadingBtn: false
			},
			editFbPrice: {},
			editIdentity: {},
			hsm:[],
			reqFbPrice: [],
			reqPriceModel: [],
			dialogAddNamespace: false,
			selectedTemplateToNamespace: '',
			selectedTemplate: {},
			loadingTemplate: true,
			loadingIdentity: false,
			currentPage: 1,
			currentPageRequest: 1,
			currentPagePriceModel: 1,
			total:'',
			totalFbPrice: '',
			totalPriceModel: '',
			dialogFormVisible:false,
			dialogFormVisibleIdentity:false,
			dialogFormVisibleEdit:false,
			dialogFormVisibleEditIdentity:false,
			loadingBtn:false,
			formLabelWidth: '200px',
			timeout: null,
			hsmParam:{
				name:'',
				namespace:'',
				message:'',
				language:''
			},
			namespaceCredentials: {
				namespace: '',
				name: '',
				message: '',
				language: '',
				templateId: ''
			},
			optionLanguage: [{
				value: 'ID',
				label: 'ID'
			}, {
				value: 'EN',
				label: 'EN'
			}, {
				value: 'EN_US',
				label: 'EN_US'
			}],
			searchTemplate:'',
			searchFbPrice:'',
			searchPriceModel:'',
			activeTab: "detail",
			activeTabSession: "index",
			loadingApproved: false
		}
	},
    components: {
        CountryFlag
    },
	methods: {
		log(message){
			console.log(message, " <<message");
		},
		doSearchFbPriceModel(){
			clearTimeout(this.timeout)
			this.timeout = setTimeout(()=>{
				this.getPriceModel(null,true)
			}, 1000)
		},
		doSearchFbPrice(){
			clearTimeout(this.timeout)
			this.timeout = setTimeout(()=>{
				this.getFbPrice()
			}, 1000)
		},
		changeFilterSession(){
			console.log("filter session");
		},
		changeFilterIdentity(){
			this.paginate = this.searchPriceModel.trim() == '' ? true:false
			this.getPriceModel(1,this.selectedFilterIdentity)
		},
		handleChangeSelectedPicBusiness(val){
            console.log(val);
        },
		async loadAdmin(page = null, search){
			// this.loadingConsumen = true
			var self = this
			await api({
				url:config.baseApi+'admin_credential?page=' + page + '&query=' + search,
				method:'GET'
			}).then(response => {
				if(response.data.ec != 200){
					// console.log('fatal error')
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
				} else {
					let admin = response.data.data.admin
					// console.log("dp_user",this.dp_user)
					// let dp_user = []
                    admin = admin.map(val => {
                        val.value = val.username
                        val.label = val.username.charAt(0).toUpperCase() + val.username.slice(1)

                        return val
                    })
					console.log('admin',admin);
                    this.options_picBusiness = admin
				}
			}).catch(error => {
				console.log("Error",error)
			})
			// this.loadingConsumen = false
		},
		find_duplicate_in_array(arra1, param) {
			var object = {};
			var result = [];

			arra1.forEach(function (item) {
			if(!object[item[param].id])
				object[item[param].id] = 0;
				object[item[param].id] += 1;
			})

			for (var prop in object) {
			if(object[prop] >= 2) {
				result.push(prop);
			}
			}

			return result;

		},
		addDataPriceModel(){
			this.mapingCountries = this.countries
			this.dialogFormVisibleIdentity = true
		},
		addModel(){
			this.price_model_identity.push({model:{periode:[null,null],modelName: "",countryName: "", domainName:""}})
		},
		addModelEdit(){
			this.editIdentity.price_model.push({facebook_price:{modelName: "",countryName: "", domainName:""}})
		},
		deleteModel(i){
			this.price_model_identity.splice(i,1)
		},
		deleteModelEdit(i){
			this.editIdentity.price_model.splice(i,1)
		},
		formatType(val){
			let result = ""
			result = val.replace("_", " ").toUpperCase();
			return result ;
		},
		formatPrice(val){
			return new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR", minimumFractionDigits: 0 }).format(val);
		},
        numberOnly(e) {
            var key = window.event ? e.keyCode : e.which;

            let isNumber = _.indexOf([8, 9, 27, 13, 190, 43], e.keyCode)
            if ( isNumber !== -1 ||
                // Allow: Ctrl+C, Command+C
                (e.keyCode === 86 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: Ctrl+A, Command+A
                (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: Ctrl+R, Command+R
                (e.keyCode === 82 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: home, end, left, right, down, up
                (e.keyCode > 42 && e.keyCode <= 49 && _.indexOf([44,45,47], e.keyCode) == -1)) {
                // let it happen, don't do anything
                return
            }
            // Ensure that it is a number and stop the keypress
            if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode > 96 || e.keyCode < 200)) {
                e.preventDefault();
            }
        },
        paste(event, field, field2 = undefined) {
            event.preventDefault()
            var totalCharacterCount = window.event.clipboardData.getData('Text');// || window.clipboardData.getData('Text');
            var strValidChars = "+0123456789";
            var strChar;
            var FilteredChars = "";
            for (var i = 0; i < totalCharacterCount.length; i++) {
                strChar = totalCharacterCount.charAt(i);
                if (strValidChars.indexOf(strChar) != -1) {
                    FilteredChars = FilteredChars + strChar;
                }
            }

			console.log(field);
			console.log(FilteredChars);

			if (field2) {
				this[field][field2] = FilteredChars
			}
			else{
				this[field] = FilteredChars
			}
        },
		async detailFbIdentity(val){
			console.log(val);
			this.editIdentity = val
			this.editIdentity.adminName = val.admin.username || ''
			if (this.editIdentity.type == 'waba_id') {
				// if (this.editIdentity.price_model.length > 0) {
				// 	this.editIdentity.price_model.forEach( async (el,i) => {
				// 		this.searchFbPrice = el.facebook_price.countryName
				// 		await this.getFbPrice()
				// 		this.reqFbPriceIdentity[i] = this.reqFbPrice
				// 	})
				// }
				// else{
				// 	this.editIdentity.price_model.push({facebook_price:{modelName: "",countryName: "", domainName:""}})
				// }
			}
			else{
				this.dialogFormVisibleEditIdentity = true
			}
			// setTimeout(() => {
			// 	this.dialogFormVisibleEditIdentity = true
			// }, 100);
		},
		async handleChangeSelectedModel(val, key){
			console.log(val);
			let find = this.reqFbPriceIdentity[key].find(el => el.id == val)
			this.price_model_identity[key].model.domainName = find ? find.domainName : null
		},
		async handleChangeSelectedModelEdit(val, key){
			console.log(val);
			let find = this.reqFbPriceIdentity[key].find(el => el.id == val)
			this.editIdentity.price_model[key].facebook_price.domainName = find ? find.domainName : null
		},
		async handleChangeSelectedCountryModel(val, key){
            console.log('val', val, key);
			this.searchFbPrice = val
			this.price_model_identity[key].model.modelName = ""
			this.price_model_identity[key].model.domainName = ""
			this.price_model_identity[key].model.id = ""
			this.loadingIdentity = true
            await this.getFbPrice()
			this.reqFbPriceIdentity[key] = this.reqFbPrice
            this.loadingIdentity = false
        },
		async handleChangeSelectedCountryModelEdit(val, key){
            console.log('val', val, key);
			this.searchFbPrice = val
			this.editIdentity.price_model[key].facebook_price.modelName = ""
			this.editIdentity.price_model[key].facebook_price.domainName = ""
			this.editIdentity.price_model[key].facebook_price.id = ""
			this.loadingIdentity = true
            await this.getFbPrice()
			this.reqFbPriceIdentity[key] = this.reqFbPrice
            this.loadingIdentity = false
        },
		handleChangeSelectedIdentity(val){
			console.log(val);
			if (val == "waba_id" && this.editIdentity.price_model.length == 0) {
				this.editIdentity.price_model.push({facebook_price:{modelName: "",countryName: "", domainName:""}})
			}
		},
        handleChangeSelectedCountry(val){
            console.log('val', val);
            let find = this.countries.find(el => el.countryNameEn == val)
            if (find) {
                this.country_code = "+" + find.countryCallingCode
                this.domain_name = find.countryCode    
            }
            
        },
		handleChangeSelectedCountryEdit(val){
            console.log('val', val);
            let find = this.countries.find(el => el.countryNameEn == val)
            if (find) {
                this.editFbPrice.country_code = "+" + find.countryCallingCode
                this.editFbPrice.domain_name = find.countryCode    
            }
            
        },
		detailFbPrice(row){
			console.log('row selectd',row)
			this.editFbPrice = row
			this.editFbPrice.model_name = row.modelName
			this.price_model_edit = '2'

			if (!this.editFbPrice.model_name) {
				this.price_model_edit = '1'
			}
			this.editFbPrice.domain_name = row.domainName
			this.editFbPrice.country_code = "+"+row.countryCode
			this.editFbPrice.country_name = row.countryName
			this.editFbPrice.dateCreate = row.dateCreate
			this.dialogFormVisibleEdit = true
		},
		deletePriceModel(row){
			console.log('row selectd',row)
			this.$confirm(`Are you sure to delete this price model?`, 'Warning', {
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                type: 'warning',
                center: true
			}).then(async () => {
                this.loadingApproved = true
                await api({
                    url: config.baseApi + `bussiness/remove-fb-price-model/${row.id}`,
                    method: 'delete'
                }).then(res => {
                    this.loadingProduct=true
                    if(res.data.ec != 200){
                        this.$swal(this.$t('error'), this.$t('error_text'), "error").then(this.clear())
                    } else {
                        this.$swal(this.$t('success'), this.$t('success'), "success").then(this.clear())
						this.paginatePriceModel()
                    }
                }).catch(err => {
                    this.$swal(this.$t('error'), this.$t('error_text'), "error")
                    return err
                })
                this.loadingApproved=false
            })
		},
		deleteFbPrice(row){
			console.log('row selectd',row)
			this.$confirm(`Are you sure to delete this price?`, 'Warning', {
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                type: 'warning',
                center: true
			}).then(async () => {
                this.loadingApproved = true
                await api({
                    url: config.baseApi + `bussiness/remove-fb-price/${row.id}`,
                    method: 'delete'
                }).then(res => {
                    this.loadingProduct=true
                    if(res.data.ec != 200){
                        this.$swal(this.$t('error'), this.$t('error_text'), "error").then(this.clear())
                    } else {
                        this.$swal(this.$t('success'), this.$t('success'), "success").then(this.clear())
						this.paginateFbPrice()
						this.paginateFbPrice(this.currentPage)
                    }
                }).catch(err => {
                    this.$swal(this.$t('error'), this.$t('error_text'), "error")
                    return err
                })
                this.loadingApproved=false
            })
		},
		getBodyText(components){
			let c = components.find(v => v.type.toLowerCase() == "body")
			if(c){
				return c.text
			} else {
				return ""
			}
		},
		tabClick(tab){
			if(tab.name == "detail"){
				// this.searchFbPrice = ""
				this.getDetail()
			} else if(tab.name == "price"){
				this.getPriceModel()
			}
		},
		deleteRow(index, rows) {
            rows.splice(index, 1);
        },
		capitalizeFirstLetter(string) {
			if(string == null || string == ""){
				return "-"
			} else {
				return string.charAt(0).toUpperCase() + string.substring(1);
			}
		},
		formatDate(val, format){
			if(val) return moment(val).format(format)
			else return "-"
		},
		async addFacebookPriceModel(){
			console.log(this.price_model_identity);
			if(_.isEmpty(this.fb_identity)){
                this.$message.error({
                    showClose: false,
                    message: 'Id fb identity is not defined'
                });
                return
            }

			let foundPeriode = this.price_model_identity.find(el => !el.model.periode || !el.model.periode[0] || !el.model.periode[1] )

			if (foundPeriode) {
				this.$message.error({
                    showClose: false,
                    message: "Please select periode !"
                });
                return
			}

			let duplicate = this.find_duplicate_in_array(this.price_model_identity,'model')
			console.log(duplicate);
			if (duplicate.length > 0) {
				this.$message.error({
                    showClose: false,
                    message: "Country Model can't duplicate"
                });
                return
			}

			this.loadingBtn = true
			var self = this
			await api({
				url:config.baseApi+'bussiness/add-fb-price-model',
				method:'POST',
				data:{
					fb_identity: this.fb_identity || this.$route.params.fb_identity,
					price_model : this.price_model_identity
				}
			}).then(response => {
                this.dialogFormVisibleIdentity = false
				if(response.data.ec != 200){
					this.$swal(this.$t('error'), (response.data.message || this.$t('error_text')), "error")
				} else {
					this.$swal(this.$t('success'), this.$t('success'), "success").then(this.clear())
					// this.dialogFormVisible = false
					this.clear()
					this.paginatePriceModel()
				}
				this.loadingBtn = false
			}).catch(error => {
                this.dialogFormVisibleIdentity = false
                this.$swal(this.$t('error'), this.$t('error_text'), "error")
                this.loadingBtn = false
				return error
			})
		},
		async editFacebookIdentity(){
			console.log(this.editIdentity);
			if(!this.editIdentity.id){
                this.$message.error({
                    showClose: false,
                    message: 'Id is undefined'
                });
                return
            }

			// let duplicate = this.find_duplicate_in_array(this.editIdentity.price_model,'facebook_price')
			// console.log(duplicate);
			// if (duplicate.length > 0) {
			// 	this.$message.error({
            //         showClose: false,
            //         message: "Country Model can't duplicate"
            //     });
            //     return
			// }

			this.loadingBtn = true
			var self = this
			await api({
				url:config.baseApi+'bussiness/update-fb-identity',
				method:'POST',
				data:{
					id: this.editIdentity.id,
					type:this.editIdentity.type,
					identityNumber:this.editIdentity.identityNumber,
					maskingName:this.editIdentity.maskingName,
					pic_business:this.editIdentity.pic_business
					// price_model:this.editIdentity.price_model
				}
			}).then(response => {
                this.dialogFormVisibleEditIdentity = false
				if(response.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
				} else {
					this.$swal(this.$t('success'), this.$t('success'), "success").then(this.clear())
					// this.dialogFormVisible = false
                    this.activeEdit = false
					this.getDetail()
				}
				this.loadingBtn = false
			}).catch(error => {
                this.dialogFormVisibleEditIdentity = false
                this.$swal(this.$t('error'), this.$t('error_text'), "error")
                this.loadingBtn = false
                this.activeEdit = false
				this.getDetail()
				return error
			})
		},
		async paginatePriceModel(page) {
			this.currentPagePriceModel = page
			await this.getPriceModel(page)
		},
        async getFbPrice(page = 1){
			this.loadingTemplate = true
			await api({
				url: config.baseApi+'bussiness/get-fb-price',
				method: 'GET',
				params: {
					page: page,
					search: this.searchFbPrice,
                    filter: true
				}
			}).then(({ data }) => {
				console.log(data);
				data.data.data.forEach(element => {
					element.price_bi = Number(element.price_bi)
					element.price_ui = Number(element.price_ui)
				});
				console.log(data.data.data);
				this.reqFbPrice = data.data.data
                this.totalFbPrice = data.data.total
				this.loadingTemplate = false
			}).catch(error => {
				this.loadingTemplate = false
			})
		},
        async getPriceModel(page = 1, filter = null){
			this.loadingTemplate = true
            let fb_identity_id = this.$route.params.fb_identity
			await api({
				url: config.baseApi+'bussiness/get-fb-price-model/' + fb_identity_id,
				method: 'GET',
				params: {
					page: page,
					all: filter ? true: null,
					filter: filter,
					search_type: this.search_type || null,
					search: this.searchPriceModel
				}
			}).then(({ data }) => {
				console.log(data.data.data);
				this.reqPriceModel = data.data.data
				this.totalPriceModel = data.data.total
				// if(filter){
				// 	this.totalFbIdentity = this.reqFbIdentity.length
				// }
				// else{
				// 	this.totalFbIdentity = data.data.total
					
				// }
				this.loadingTemplate = false
			}).catch(error => {
				this.loadingTemplate = false
			})
		},
		async getDetail(){
			this.loadingTemplate = true
            let fb_identity_id = this.$route.params.fb_identity
			await api({
				url: config.baseApi+'bussiness/get-fb-identity/' + fb_identity_id,
				method: 'GET',
			}).then(({ data }) => {                
                this.editIdentity = data.data ? data.data : {}
                this.editIdentity.adminName = this.editIdentity.admin.username || ""
				this.loadingTemplate = false
			}).catch(error => {
				this.loadingTemplate = false
			})
		},
		clear(){
			// this.editFbPrice = {}
			// this.editIdentity = {}
			this.price_model_identity = [{model:{periode:[null,null],modelName: "",countryName: "", domainName:""}}]
			this.price_bi = 0
            this.price_ui = 0
            this.country_code = ''
            this.country_name = ""
            this.domain_name = ''
            this.model_name =""
            this.price_model = "1",
			this.type_identity = "waba_id"
			this.maskingName = ""
			this.identityNumber = ""
		}
	},
	async mounted(){
        // await this.paginateFbPrice()
        await this.getDetail()
        this.fb_identity = this.$route.params.fb_identity
        this.getPriceModel()
		this.loadAdmin()
	},
    created(){
        this.countries = countryCodes.all()
    }
}
</script>

<style lang="scss" scoped>
.float-image {
	float:right;
	z-index: 1;
	bottom: 10px;
	left: 10px;
}
.fl-r {
	float:right;
}
.gradient-api {
	background:#249393;
	background: linear-gradient(260deg, #4ac5c5, #249393);
}
.white-text {
	color: white;
}
.page-header {
	margin-bottom: 30px;
}
</style>
